import styled from 'styled-components';

export const DiscountsWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 30px;
    align-items: center;
    flex-direction: column;
`;

export const DiscountRowWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
`;

export const ImageInputWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const ProductImage = styled.img`
    height: 50px;
    width: 50px;
    margin-right: 30px;
`;
